module.exports = __webpack_public_path__ + "img/sidebar-bg-sm.48d17cd3.png";